export default __webpack_public_path__ + "img/vauxhall-logo.ce8060cc.png";